import { getBaseUrl, getFullLocale } from '@/helpers/index';
import { getMetaImageSrc } from '@/helpers/image-resources';
import { isProdSite, isTestEnv } from '@/helpers/deployment';


export const hasTag = function (meta, obj) {
    return !!_.filter(meta, obj).length;
};

export const getMetaInfo = function (pageInfo, route, item, noindex, siteName, locale) {
    var rv;
    const titleTemplate = typeof pageInfo.titleTemplate !== 'undefined' ?
        pageInfo.titleTemplate
        : `%s | ${siteName}`;

    const title = typeof pageInfo.title !== 'undefined' ?
        pageInfo.titleTemplate
        : ' ';

    const meta = _.clone(pageInfo.meta) || [];
    delete pageInfo.meta;

    if (!hasTag(meta, {name: 'robots'})) {
        meta.push({
            // do not index development sites, nor pages that set the noindex param
            name: 'robots',
            content: (isProdSite || isTestEnv) && !noindex ?
                'index,follow,noarchive'
                : 'noindex,nofollow,noarchive,noodp,noydir,nosnippet'
        });
    }

    // og:type
    if (!hasTag(meta, {property: 'og:type'})) {
        meta.push({
            property: 'og:type',
            content: 'website'
        });
    }

    // og:site_name
    meta.push({
        property: 'og:site_name',
        content: siteName
    });

    // og:locale
    if (!hasTag(meta, {property: 'og:locale'})) {
        meta.push({
            property: 'og:locale',
            content: getFullLocale(locale)
        });
    }

    // og:title
    if (pageInfo.title && !hasTag(meta, {property: 'og:title'})) {
        meta.push({
            property: 'og:title',
            content: pageInfo.title
        });
    }

    if (item) {
        // og:description
        if (!hasTag(meta, {property: 'og:description'})) {
            const description = item.TagLine || item.IngressText || item.DescriptionHtml;
            if (description) {
                meta.push({
                    property: 'og:description',
                    content: description
                });
            }
        }

        if (!hasTag(meta, {property: 'og:metrics'})) {
            if (item.Metrics && item.Metrics.Primary) {
                meta.push({
                    property: 'og:metrics',
                    content: item.Metrics.Primary
                });
                pageInfo.afterNavigation = function() { console.log('afterNavigation ' + item.Metrics.Primary)};// eslint-disable-line no-alert
                pageInfo.changed = function(newInfo, addedTags, removedTags) {
                    //console.log('Metadata was updated!', newInfo, addedTags, removedTags)
                  };
            }
        }


        // og:image
        if (!hasTag(meta, {property: 'og:image'})) {
            let imageSrc = getMetaImageSrc(item);
            if (imageSrc) {
                imageSrc = imageSrc.replace(/&amp;/g,'&').replace(/&/g,'&amp;');
            }
            if (imageSrc) {
                meta.push({
                    property: 'og:image',
                    content: imageSrc
                });
                // set Twitter card type when image is set (NOTE: is "name", not "property")
                if (!hasTag(meta, {name: 'twitter:card'})) {
                    meta.push({
                        name: 'twitter:card',
                        content: 'summary_large_image'
                    });
                }
                // also possible to add property twitter:image:alt with image caption
            }
        }
    }

    // og:url
    if (route) {
        meta.push({
            property: 'og:url',
            content: getBaseUrl() + (route.path || '')
        });
    }
    rv = _.merge({
        htmlAttrs: {
            lang: locale,
            prefix: 'og: https://ogp.me/ns#'
        },
        meta,
        title,
        titleTemplate
    }, pageInfo);
    return _.merge({
        htmlAttrs: {
            lang: locale,
            prefix: 'og: https://ogp.me/ns#'
        },
        meta,
        title,
        titleTemplate
    }, pageInfo);
};


/**
 * Mixin to format metadata for vue-meta.
 */
export default {

    methods: {
        getMetaInfo: function (pageInfo, route, item, noindex) {
            // add site and locale parameters
            return getMetaInfo(pageInfo, route, item, noindex, this.$site, this.$i18n.locale);
        },

        getMetaImageSrc
    }
};
